// MAN CLINICS - Static Content Data

export const clinicData = {
  name: "MAN CLINICS",
  tagline: "Men's Health and Andrology",
  specialties: ["Men's Health", "Andrology", "Urology"],

  contact: {
    phone: "8008130303",
    alternatePhone: "8008156565",
    whatsappNumber: "8008130303",
    address: "1st Floor, Taj Balaji Chambers, 9-1-224, Above Lakshmi Hyundai, Besides Subham Prema Hospital, Rama Talkies Junction, CBM Compound, Vizag – 530003",
    email: "info@manclinics.com",
    mapUrl: "https://maps.google.com/?q=MAN+CLINICS+Vizag"
  },

  about: {
    title: "Who We Are",
    content: "Man Clinics is a super speciality clinic established exclusively for treating male sexual health and infertility by an enthusiastic group of Genitourinary Surgeons. They provide comprehensive care and guidance with confidentiality."
  },

  specialTechnologies: [
    {
      name: "Peizo Wave 2 LI-SWT",
      description: "First center to introduce Peizo Wave 2 LI-SWT for Erectile Dysfunction in Andhra Pradesh"
    },
    {
      name: "HIFEM",
      description: "High Intensity Focused Electromagnetic Technology"
    }
  ],

  doctors: [
    {
      name: "Dr Kalyan Babu Ch.",
      qualifications: "MS, FMAS, DNB (URO)",
      designation: "Urologist, Andrologist & Renal Transplant Surgeon",
      image: "/images/doctor-v1.jpeg"
    },
    {
      name: "Dr Shanti Vardhan G",
      qualifications: "MBBS, DNB, DrNB (URO)",
      designation: "Consultant Urologist, Andrologist & Male Fertility Specialist",
      image: "/images/dr-santha-vardhan.jpeg"
    },
    {
      name: "Dr Goutam Banga",
      qualifications: "MBBS, MS, MCh (Uro)",
      designation: "Consultant Urologist / Andrologist, National faculty – Prosthetic & Reconstructive Urology",
      image: "/images/gallery/558396442_17849743065565477_1547477101215270600_n.webp"
    },
    {
      name: "Dr Samir Bagadia",
      qualifications: "MBBS, MS, DNB (URO)",
      designation: "Urologist / Andrologist, Robotic Surgeon",
      image: "/images/gallery/559555295_17850012957565477_2186534155120257970_n.webp"
    }
  ],

  services: [
    {
      id: "male-infertility",
      title: "Male infertility evaluation and treatment",
      icon: "Users",
      description: "Comprehensive evaluation and treatment for male infertility issues"
    },
    {
      id: "erectile-dysfunction",
      title: "Erectile Dysfunction (ED) management",
      icon: "Heart",
      description: "Advanced treatment options for erectile dysfunction"
    },
    {
      id: "premature-ejaculation",
      title: "Premature ejaculation and sexual disorders",
      icon: "Clock",
      description: "Treatment for premature ejaculation and other sexual disorders"
    },
    {
      id: "penile-disorders",
      title: "Correction of congenital disorders of penis & scrotum",
      icon: "Activity",
      description: "Surgical correction for congenital penile and scrotal disorders"
    },
    {
      id: "hypospadias",
      title: "Hypospadias",
      icon: "Scissors",
      description: "Surgical treatment for hypospadias"
    },
    {
      id: "penile-curvature",
      title: "Congenital penile curvature",
      icon: "GitCommit",
      description: "Treatment for congenital penile curvature"
    },
    {
      id: "reproductive-surgery",
      title: "Male reproductive organ surgery",
      icon: "Knife",
      description: "Surgical procedures for male reproductive organs"
    },
    {
      id: "peyronies",
      title: "Peyronie's disease",
      icon: "AlertCircle",
      description: "Treatment for Peyronie's disease"
    },
    {
      id: "urethroplasty",
      title: "Urethroplasty",
      icon: "Stethoscope",
      description: "Surgical reconstruction of the urethra"
    }
  ],

  alliedServices: [
    {
      name: "Psychosexual counselling"
    },
    {
      name: "Psychotherapy"
    },
    {
      name: "CBT (Cognitive Behaviour Therapy)"
    },
    {
      name: "Endocrinology & hormonal disorder treatment"
    },
    {
      name: "Pre-marital counselling and genetic screening"
    }
  ],

  bphProcedures: [
    {
      name: "MIST – Minimally Invasive Surgical Therapies"
    },
    {
      name: "Urolift"
    },
    {
      name: "Rezum"
    },
    {
      name: "iTIND"
    },
    {
      name: "Laser Prostate Surgery"
    },
    {
      name: "HoLEP"
    },
    {
      name: "ThuFLEP"
    }
  ],

  prostheticUrology: [
    {
      name: "Artificial urinary sphincter"
    },
    {
      name: "Penile implant surgery"
    }
  ],

  whyChooseUs: [
    {
      title: "Expert Specialist Care",
      description: "Team of highly qualified Urologists and Andrologists with extensive experience",
      icon: "Award"
    },
    {
      title: "Advanced Technology",
      description: "Latest medical technology including Peizo Wave 2 and HIFEM",
      icon: "Cpu"
    },
    {
      title: "Confidential & Comfortable",
      description: "Complete privacy, comfortable environment, and compassionate care",
      icon: "Lock"
    },
    {
      title: "Evidence-Based Treatment",
      description: "Scientifically proven treatment protocols following international standards",
      icon: "BookOpen"
    }
  ],

  clinicFeatures: [
    {
      title: "State-of-the-Art Equipment",
      description: "Latest medical technology for accurate diagnosis and minimally invasive treatments",
      icon: "Microscope",
      image: "/images/clinic_equipment_1768065722997.png"
    },
    {
      title: "Private Consultation Rooms",
      description: "Comfortable, confidential spaces designed for your privacy and comfort",
      icon: "Lock",
      image: "/images/consultation_1768065683336.png"
    },
    {
      title: "Advanced Technology",
      description: "First center in Andhra Pradesh with Peizo Wave 2 LI-SWT for ED treatment",
      icon: "Zap",
      image: "/images/service_ed_1768065707472.png"
    },
    {
      title: "Expert Medical Team",
      description: "Experienced professionals dedicated to your health and wellness",
      icon: "Users",
      image: "/images/gallery/561746267_17850532290565477_1267530975282058043_n.webp"
    }
  ],

  statistics: [
    { number: "10+", label: "Years Experience", icon: "Award" },
    { number: "5000+", label: "Happy Patients", icon: "Users" },
    { number: "95%", label: "Success Rate", icon: "TrendingUp" },
    { number: "1000+", label: "Surgeries Performed", icon: "Activity" }
  ],

  seo: {
    home: {
      title: "MAN CLINICS Vizag | Men's Health, Andrology & Urology Specialist",
      description: "Expert men's health care in Vizag. Specializing in erectile dysfunction, male infertility, prostate health & more."
    },
    about: {
      title: "About MAN CLINICS - Men's Health & Andrology Clinic in Vizag",
      description: "MAN CLINICS is a super speciality clinic for male sexual health and infertility. Our team of Genitourinary Surgeons provides comprehensive care."
    },
    treatments: {
      title: "Men's Health Treatments | Urology & Andrology Services - MAN CLINICS",
      description: "Comprehensive urology and andrology treatments: erectile dysfunction, male infertility, premature ejaculation, prostate care in Vizag."
    },
    contact: {
      title: "Contact MAN CLINICS Vizag | Book Appointment",
      description: "Schedule your confidential consultation at MAN CLINICS, Vizag. Call 8008130303 / 8008156565."
    }
  },

  disclaimer: "The information provided on this website is for educational purposes only and should not be considered as medical advice. Always consult with a qualified healthcare professional for diagnosis and treatment. Individual results may vary."
};

